import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import {TmsDemirbasService} from "../ctl-tms-demirbas.service";

@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private tmsDemirbasService : TmsDemirbasService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([]);
            const filterArr = [];
            if (this.tmsDemirbasService.ambarKod) filterArr.push(['AmbarKod', '=', this.tmsDemirbasService.ambarKod]);
            if (this.tmsDemirbasService.verilenPersonelKod) filterArr.push(['VerilenPersonelKod', '=', this.tmsDemirbasService.verilenPersonelKod]);
            if (this.tmsDemirbasService.demirbasYerKod) filterArr.push(['DemirbasYerKod', '=', this.tmsDemirbasService.demirbasYerKod]);
            if (this.tmsDemirbasService.islemTuru) filterArr.push(['IslemTuru', '=', this.tmsDemirbasService.islemTuru]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
